import React, { Component } from "react";
import { withRouter, RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

import { hallsStoreSelectors } from "../../../store/store";

import { formatDateText } from "../../../../../utils/utils";
import UserAvatar from "../../../../home/components/Topbar/LoggedInUser/UserAvatar/UserAvatar.component";

import "./ActivityFeed.component.scss";
import { HallsActionCreators } from "../../../actions/actionCreators";
import { ActionCreator } from "../../../../../actions/actions";

export interface ActivityFeedProps extends RouteComponentProps {
    getLicenseActivity: ActionCreator;
    serverId: number;
    licenseActivities: any;
    licenseActivitiesLoading: boolean;
    licenseActivitiesPage: number;
    maxHeight: number;
}

const PAGE_SIZE = 12;

class ActivityFeed extends Component<ActivityFeedProps, {}> {
    constructor(props) {
        super(props);

        this.props.getLicenseActivity({
            serverId: this.props.serverId,
            page: 0,
            top: PAGE_SIZE
        });
    }

    renderDayOperation = activity => {
        const operationTime = new Date(activity.date)
            .toTimeString()
            .split(" ")[0];

        return (
            <li
                key={`${activity.type}-${activity.date}`}
                className="activity-item"
            >
                {activity.user.email === '' && activity.user.id === 0 ?
                    <div className="user-photo">
                        <UserAvatar email={"wave_system"} size={28}/>
                    </div>
                    :
                    <div className="user-photo">
                        <UserAvatar email={activity.user.email} size={28}/>
                    </div>
                }
                <div className="activity-info">
                    <div>
                        <p>
                            <span>
                                {activity.user.first_name + ' ' + activity.user.last_name}
                            </span>
                            {activity.license_activity_type.name}
                        </p>
                    </div>
                    <div>@ {operationTime}</div>
                </div>
            </li>
        );
    };

    renderDay = (key, day) => {
        return (
            <div key={key} className="activity-day">
                <p>{formatDateText(key, "short", true, true, true)}</p>
                <ul>
                    {_.orderBy(day, ["date"], ["desc"]).map(activity =>
                        this.renderDayOperation(activity)
                    )}
                </ul>
            </div>
        );
    };

    render() {
        return (
            <div className="activity-feed" style={{maxHeight: this.props.maxHeight}}>
                <div>
                    <h1>License activity feed</h1>
                    {this.props.licenseActivitiesLoading && (
                        <div className="loading">
                            <Components.LoadingRipple
                                height={100}
                                width={100}
                            />
                        </div>
                    )}
                    {!this.props.licenseActivitiesLoading &&
                        this.props.licenseActivities.activities &&
                        Object.keys(this.props.licenseActivities.activities)
                            .length == 0 && (
                            <div className="no-license-activity">
                                No Activity
                            </div>
                        )}
                    {this.props.licenseActivities &&
                        this.props.licenseActivities.activities &&
                        Object.keys(this.props.licenseActivities.activities)
                            .length > 0 && (
                            <div>
                                {Object.keys(
                                    this.props.licenseActivities.activities
                                ).map(key => {
                                    return this.renderDay(
                                        key,
                                        this.props.licenseActivities.activities[
                                            key
                                        ]
                                    );
                                })}
                                {!this.props.licenseActivitiesLoading &&
                                    !this.props.licenseActivities.finished && (
                                        <div className="load-more">
                                            <button
                                                onClick={() => {
                                                    this.props.getLicenseActivity(
                                                        {
                                                            serverId: this.props
                                                                .serverId,
                                                            page:
                                                                this.props
                                                                    .licenseActivitiesPage +
                                                                1,
                                                            top: PAGE_SIZE
                                                        }
                                                    );
                                                }}
                                            >
                                                Load more
                                            </button>
                                        </div>
                                    )}
                                {this.props.licenseActivitiesLoading && (
                                    <div className="load-more">Loading...</div>
                                )}
                            </div>
                        )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    licenseActivities: hallsStoreSelectors.licenseActivities(state),
    licenseActivitiesLoading: hallsStoreSelectors.licenseActivitiesLoading(
        state
    ),
    licenseActivitiesPage: hallsStoreSelectors.licenseActivitiesPage(state)
});

const mapDispatchToProps = {
    getLicenseActivity: HallsActionCreators.getLicenseActivity
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ActivityFeed));
